import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';


// Add global error handlers for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Render with Error Boundary
try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} catch (error: any) {
  // Fallback if React itself fails to render
  console.error('Failed to render app:', error);
  const errorMessage = error?.message || String(error) || 'Unknown error';
  rootElement.innerHTML = `
    <div style="padding: 2rem; text-align: center; font-family: system-ui; max-width: 600px; margin: 2rem auto; min-height: 100vh; display: flex; align-items: center; justify-content: center;">
      <div style="background: white; padding: 2rem; border-radius: 12px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <h1 style="color: #dc2626; margin-bottom: 1rem;">Application Error</h1>
        <p style="color: #6b7280; margin-bottom: 1rem;">Failed to load the application. Please check the console for details.</p>
        <pre style="background: #f3f4f6; padding: 1rem; margin-top: 1rem; text-align: left; overflow: auto; border-radius: 8px; font-size: 12px; max-height: 300px;">${errorMessage}</pre>
        <button onclick="window.location.reload()" style="margin-top: 1rem; padding: 0.75rem 1.5rem; background: #1f2937; color: white; border: none; border-radius: 8px; cursor: pointer;">Try Again</button>
        <p style="margin-top: 1rem; color: #6b7280; font-size: 14px;">Check the browser console (F12) for more details.</p>
      </div>
    </div>
  `;
}
